module.exports = __webpack_public_path__ + "static/ey-6-4e493949a58171385c20f42f2b3943ed.png";